import React from 'react'

export default function Accordion() {
  return (
    <>
      <h1>Accordion</h1>
      <p><span className='tag-grey bold'>.accordion</span> class creates a stylized container with a drop down </p>
      <p className='italic'>This requires the .js file of this library to function properly</p>
      <p> adding the <span className='tag-grey bold'>.accordion-dark</span> class to the accordion changes the color style to dark mode</p>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;div class="accordion active accordion-dark"&gt;<br/>
            &lt;div class="accordion-bar"&gt;<br/>
                &lt;p&gt;hhh&lt;/p&gt; <br />
                &lt;i class="accordion-button"&gt;&lt;/i&gt;<br/>
            &lt;/div&gt;<br/>
            &lt;div class="accordion-body"&gt; ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing<br/>
            &lt;/div&gt;<br/>
            &lt;/div&gt;<br/>
            &lt;div class="accordion accordion-dark"&gt;<br/>
                &lt;div class="accordion-bar"&gt;<br/>
                    &lt;p&gt;fff&lt;/p&gt;<br/>
                    &lt;p class="accordion-button"&gt;&lt;/p&gt;<br/>
                &lt;/div&gt;<br/>
                &lt;div class="accordion-body"&gt;ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing<br/>
                &lt;/div&gt;<br/>
            &lt;/div&gt;<br/>
          </p>
      </div>

      <h2>Result:</h2>
      <p> adding the <span className='tag-grey bold'>.active</span> class to the accordion opens it's content by default</p>
      <div className='border-grey p-1 border-curve'>
      <div className="accordion active">
        <div className="accordion-bar">
            <p>hhh</p>
            <i className="accordion-button"></i>
        </div>
        <div className="accordion-body">
            ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing
        </div>
      </div>
      <div className="accordion accordion-dark">
          <div className="accordion-bar">
              <p>fff</p>
              <p className="accordion-button"></p>
          </div>
          <div className="accordion-body"> ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing
          </div>
      </div>
      </div>
    </>
  )
}
